module.exports = __webpack_public_path__ + "img/nonfinancial.12656549.jpg";